import "./products.css";
import rectangularDuctingImg from "./static/rectangular_ducking.png";
import rectangularFittingsImg from "./static/rectangular_fittings.png";
import fireRatedDuctworkImg from "./static/fire-reated_duckwork.png";
import ductAccessoriesImg from "./static/duct_accessories.png";
import customFabricationImg from "./static/custom_fabrication.png";
import spiralDuctworkImg from "./static/spiral_ductwork.png";
import { Button, Container, Header, Card, Image } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../store/store";
import { setActiveMenuItem } from "../../store/reducer";

const Products = () => {
    const navigate = useNavigate();
    const [, dispatch] = useStore();

    const products = [
        {
            key: "rectangularDucting",
            title: "Rectangular Ducting",
            image: rectangularDuctingImg,
            description: "Straight duct sections manufactured to specification for reliable airflow, installation and project coordination."
        },
        {
            key: "rectangularFittings",
            title: "Rectangular Fittings",
            image: rectangularFittingsImg,
            description: "Bends, offsets, transitions and branches formed for accurate connections across complex ventilation layouts."
        },
        {
            key: "fireRatedDuctwork",
            title: "Fire-Rated Ductwork",
            image: fireRatedDuctworkImg,
            description: "Specialist ductwork for fire-rated ventilation, smoke control and extract systems where performance matters."
        },
        {
            key: "ductAccessories",
            title: "Duct Accessories",
            image: ductAccessoriesImg,
            description: "Supporting components, fixings and finishing details that help ductwork systems install cleanly and securely."
        },
        {
            key: "customFabrication",
            title: "Custom Fabrication",
            image: customFabricationImg,
            description: "Bespoke metalwork and duct components produced for non-standard layouts, plantrooms and site constraints."
        },
        {
            key: "spiralDuctwork",
            title: "Spiral Ductwork",
            image: spiralDuctworkImg,
            description: "Round spiral ducting and matching components for efficient air distribution and exposed ceiling applications."
        }
    ];

    const handleQuoteClick = (event) => {
        event.preventDefault();
        dispatch(setActiveMenuItem("/contact"));
        navigate("/contact");
    };

    return (
        <Container className="products">
            <Header textAlign="center" as="h1" content="Products" className="products-name" />
            <p className="products-intro">
                Manufactured ventilation products for commercial, industrial and specialist ductwork projects.
            </p>
            <div className="products-quote">
                <Button primary size="large" className="products-quote-button" onClick={handleQuoteClick}>
                    Request Quote
                </Button>
            </div>
            <Card.Group itemsPerRow={3} stackable doubling className="products-grid">
                {products.map(({ key, title, image, description }) => (
                    <Card key={key} className="products-card" raised>
                        <Image src={image} alt={title} className="products-image" fluid />
                        <Card.Content textAlign="center">
                            <Card.Header className="products-title">{title}</Card.Header>
                            <Card.Description className="products-desc">{description}</Card.Description>
                        </Card.Content>
                    </Card>
                ))}
            </Card.Group>
        </Container>
    );
};

export default Products;
